import { render, staticRenderFns } from "./DeodorizerTest.vue?vue&type=template&id=60f168df&scoped=true"
import script from "./DeodorizerTest.vue?vue&type=script&lang=js"
export * from "./DeodorizerTest.vue?vue&type=script&lang=js"
import style0 from "./DeodorizerTest.vue?vue&type=style&index=0&id=60f168df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f168df",
  null
  
)

export default component.exports